module.exports = __webpack_public_path__ + "static/media/graph-2.ddb2b8e9.png";